import Icons, { IconsProps } from '../../Icons';

export type MoreVertProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/

export function MoreVert(props: MoreVertProps) {
  return (
    <Icons {...props}>
      <path d="M12 18.55c-.283 0-.52-.1-.712-.3a.979.979 0 0 1-.288-.7c0-.283.096-.521.288-.713A.967.967 0 0 1 12 16.55a.97.97 0 0 1 .713.287.97.97 0 0 1 .287.713.98.98 0 0 1-.287.7c-.192.2-.43.3-.713.3zM12 13a.965.965 0 0 1-.712-.288A.965.965 0 0 1 11 12c0-.283.096-.521.288-.713A.967.967 0 0 1 12 11a.97.97 0 0 1 .713.287A.97.97 0 0 1 13 12c0 .283-.096.52-.287.712A.968.968 0 0 1 12 13zm0-5.55a.965.965 0 0 1-.712-.288A.965.965 0 0 1 11 6.45c0-.267.096-.5.288-.7.191-.2.429-.3.712-.3s.521.1.713.3c.191.2.287.433.287.7 0 .283-.096.52-.287.712A.968.968 0 0 1 12 7.45z" />
    </Icons>
  );
}
